function FilmList({ films, onDelete, onEdit }) {
  if (films.length === 0) {
    return (
      <div className="text-center text-muted">
        Henüz film eklenmedi.
      </div>
    );
  }

  return (
    <div className="d-flex flex-column gap-4">
      {films.sort((a, b) => b.id - a.id).map((film) => (
        <div className="col-md-12" key={film.id}>
          <div className="border rounded-4 p-4 h-100 shadow-sm">

            <div className="d-flex justify-content-between align-items-start">
              <h5 className="fw-bold">{film.ad}</h5>
              <span className="badge bg-dark">
                ⭐ {film.puan}
              </span>
            </div>

            <p className="text-muted small mb-2">
              {film.tur} • {film.tarih}
               {/* {film.tur} */}
            </p>

            <p className="mb-3">{film.not}</p>

            <div>
              <button
                className="btn btn-outline-secondary btn-sm me-2"
                onClick={() => onEdit(film)}
              >
                Düzenle
              </button>

              <button
                className="btn btn-outline-danger btn-sm"
                onClick={() => onDelete(film.id)}
              >
                Sil
              </button>
            </div>

          </div>
        </div>
      ))}
    </div>
  );
}

export default FilmList;